var utils     = require( './utils' ),
	scroll_to = require( './scroll-to' );

var fp_hero = ( function( $ ) {

	var $container;

	var _init = function() {
		$container = $( '#fp-scroll-top' );

		$container.find( 'a.scroll-to-top' ).on( 'click', function( e ) {
			e.preventDefault();
			scroll_to.scroll_to( $( 'html' ) );
		} );

		_maybe_show_scroll();

		$( window ).smartresize( function() {
			_maybe_show_scroll()
		} );

		$( window ).on( 'scroll', _maybe_show_scroll );
	};

	var _maybe_show_scroll = function() {
		if ( utils.viewport_size().width < 992 ) {
			_hide_scroll_top();
			return;
		}

		if ( element_is_in_view( $( '#fp-hero' ) ) ) {
			_hide_scroll_top();
			return;
		}

		if ( is_colliding( $container, $( '#footer' ) ) ) {
			_hide_scroll_top();
			return;
		}

		_show_scroll_top();
	};

	var element_is_in_view = function( $elem ) {
		var element_top = $( $elem ).offset().top;
		var element_bottom = element_top + $( $elem ).outerHeight();

		var viewport_top = $( window ).scrollTop() + $( '#header' ).outerHeight();
		var viewport_bottom = viewport_top + $( window ).height();

		return element_bottom > viewport_top && element_top < viewport_bottom;
	};

	var _show_scroll_top = function() {
		if ( $container.hasClass( 'shown' ) ) {
			return;
		}

		$container.fadeIn();
		$container.addClass( 'shown' );
	};

	var _hide_scroll_top = function() {

		if ( ! $container.hasClass( 'shown' ) ) {
			return;
		}

		$container.fadeOut( 100 );
		$container.removeClass( 'shown' );
	};

	if ( $( '#fp-scroll-top' ).length > 0 ) {
		$( document ).ready( _init );
	}

	var is_colliding = function( $elem_1, $elem_2 ) {
		// Elem 1 data
		var elem_1_offset        = $elem_1.offset(),
			elem_1_height        = $elem_1.outerHeight( true ),
			elem_1_width         = $elem_1.outerWidth( true ),
			elem_1_distance_top  = elem_1_offset.top + elem_1_height,
			elem_1_distance_left = elem_1_offset.left + elem_1_width;

		// Elem 2 data
		var elem_2_offset             = $elem_2.offset(),
			elem_2_height             = $elem_2.outerHeight( true ),
			elem_2_width              = $elem_2.outerWidth( true ),
			elem_2_distance_from_top  = elem_2_offset.top + elem_2_height,
			elem_2_distance_from_left = elem_2_offset.left + elem_2_width;

		var not_colliding = ( elem_1_distance_top < elem_2_offset.top || elem_1_offset.top > elem_2_distance_from_top || elem_1_distance_left < elem_2_offset.left || elem_1_offset.left > elem_2_distance_from_left );

		// Return whether it IS colliding
		return ! not_colliding;
	};

	return {
		element_is_in_view: element_is_in_view,
		is_colliding : is_colliding
	}

} )( jQuery );

module.exports = fp_hero;